/**
 * League of Managers - Mock Leagues & Multi-League Data
 */

import { LeagueSummary, User } from '../types';

export const CURRENT_USER: User = {
  id: 'usr-manager-007',
  email: 'entrenador@footballmanager.com',
  name: 'Mánager Carlos Mendoza',
  role: 'Entrenador Jefe & Director Deportivo',
  avatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=120&auto=format&fit=crop&q=80',
};

export const INITIAL_LEAGUES: LeagueSummary[] = [
  {
    id: 'comp-global-01',
    name: 'Liga Global de Mánagers',
    description: 'Competición oficial del sistema de divisiones, ascensos y descensos.',
    type: 'GLOBAL',
    season: '2026/27',
    totalClubs: 6,
    userClubId: '',
    userClubName: '',
    userClubCode: '',
    userPosition: 1,
    userPoints: 0,
    currentMatchdayNumber: 8,
    totalMatchdays: 38,
    activeUsersCount: 6,
    badgeColor: '#2563eb', // Blue
  },
];
